import '../scss/main.scss';
import './swiper-slider';
import './reports-map';
import './form-registration';
import './reports-summary';
import './reports-top-regions-text';
import './top-regions-card';
import './reports-counter';
import './problem-scale-card';
import './reports-voivodeship-card';
import './reports-voivodeship-text';
import './purchases-pie-chart';
import './reports-monthly-counter';